import { __makeTemplateObject } from "tslib";
import { styled, visuallyHiddenStyles } from '../../foundation';
var RcVisuallyHidden = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), visuallyHiddenStyles);
RcVisuallyHidden.displayName = 'RcVisuallyHidden';
export { RcVisuallyHidden };
var templateObject_1;
